import _ from 'underscore';
import { PureKnockoutView } from '@bingads-webui/knockout-view';
import { globalContext } from '@bingads-webui-campaign/injection-context';
import { TrackingTemplateView } from './view';
import template from '../shared/inline-edit/template.pug';
import ViewModel from '../shared/inline-edit/viewmodel';


/**
 * save event - When save button clicked, it fires with the new custom parameters.
 * It carries a parameter with format of { trackingTemplate }
 * @event TrackingTemplateInlineEditView#save
 * @type {Object}
 */

/**
 * close event - When cancel button clicked, it fires close event.
 *
 * @event TrackingTemplateInlineEditView#close
 * @type {void}
 */

/**
 * TrackingTemplateInlineEditView
 * will disable save button when input invalid
 *
 * @fires TrackingTemplateInlineEditView#save
 * @fires TrackingTemplateInlineEditView#close
 */
export class TrackingTemplateInlineEditView extends PureKnockoutView {
  /**
   * Initilize tracking template view settings
   *
   * @param {Object} param - An object containing these default options for view:
   * @param {Object} param.i18n - the localization settings
   * @param {Object} param.i18n.getString - localization settings function
   * @param {String} param.trackingTemplate - tracking template
   * @returns {void} void
  */
  initialize({
    i18n,
    trackingTemplate,
    showUurlTestTool,
    isForVNext,
    deps = null,
  }) {
    super.initialize({ i18n, trackingTemplate });

    this.i18n = i18n;
    this.trackingTemplateView = new TrackingTemplateView({
      i18n,
      editMode: true,
      trackingTemplate,
      showUurlTestTool,
    });

    this.trackingTemplateView.on('trackingTemplate:updated', ({ isValid }) => {
      this.viewModel.isValid(isValid);
    });

    this.viewModel.isValid(this.trackingTemplateView.isValid());

    this.setChild('childView', this.trackingTemplateView);

    if (showUurlTestTool) {
      let UurlTestToolView;

      // TODO: refactor this part later
      try {
        UurlTestToolView = globalContext.require('component/upgraded-url/view/urlTestTool');
      } catch (e) {
        if (deps) {
          UurlTestToolView = deps.uurlTestToolView;
        } else {
          return;
        }
      }

      if (UurlTestToolView) {
        setTimeout(() => {
          const urlTestTool = new UurlTestToolView({
            urlTestToolStatusContainer: this.$('.uurl-test-info__container'),
            isForVNext,
          });

          this.$('.uurl-test-tool__container').empty().append(urlTestTool.render().el);
          urlTestTool.on('testUurl', (fn, originalView) => {
            this.trigger('testUurl', fn, originalView);
          });
        }, 50);
      }
    }
  }

  get events() {
    return {
      'click .btn-primary': 'save',
      'click .btn-default.grid-popupeditor-cancel': 'cancel',
    };
  }

  get template() {
    return ({ model }) => template({ model, i18n: this.i18n });
  }

  get ViewModel() {
    return ViewModel;
  }

  /**
   * Fires save event after click save button
   *
   * @fires TrackingTemplateInlineEditView#save
   * @returns {void}
   */
  save() {
    this.trigger('save', { trackingTemplate: this.trackingTemplateView.getTrackingTemplate() });
  }

  /**
   * Fires close event after click cancel button
   *
   * @fires TrackingTemplateInlineEditView#close
   * @returns {void}
   */
  cancel() {
    this.trigger('close');
  }

  setErrors(errors) {
    if (errors && !_.isEmpty(errors) && _.isObject(errors)) {
      this.viewModel.error(errors[_.keys(errors)[0]]);
    } else {
      this.viewModel.error('');
    }
  }
}
